import React from "react";

// state
import { useAppDispatch, useAppSelector } from "../../../store";
import { IService } from "../../../store/types/service";
import { delete_service, get_services } from "../../../services/apis/services";

// components
import EditService from "../edit";
import CreateService from "../create";
import Button from "../../../component/element/forms/Button";
import DataTable from "../../../component/element/table";
import ItemAction from "../../../component/ui/action/ItemAction";

// constants and icon
import { ColumnDef } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";

const Services = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  
  const loadingServiceId = useAppSelector(({ service }) => service.loadingServiceId);
  const services = useAppSelector(({ service }) => service.services);

  const [show, showSet] = React.useState<boolean>(false);
  const [edit, editSet] = React.useState<string>("");

  // /**
  //  * Handles the deletion of a service by calling `delete_service` api
  //  * and sets loading state of the item to true while the deletion is in progress
  //  * @param {string} id - The id of the service to delete
  //  */
  // const onDelete = async (id: string) => {
  //   dispatch(setLoading()); // Set loading to true

  //   try {
  //     await delete_service(dispatch, id);
  //   } finally {
  //     dispatch(disableLoading()); // Stop loading
  //   }
  // };
  // //************************************************************************//

  const onLoad = React.useCallback(() => {
    get_services(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<IService>[] = [
    {
      accessorKey: "image",
      header: "Image",
      cell: ({ getValue }) => {
        const image = getValue() as string;
        return (
          <img
            src={image}
            alt={image}
            className="w-10 h-auto object-cover rounded-md"
          />
        );
      },
    },
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue }) => {
        const name = getValue() as string;
        return name;
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ getValue }) => {
        const status = getValue() as string;
        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${status === "1" ? "bg-primary-100/50 text-primary-500" : "bg-red-50 text-red-800"}`}
          >
            {status === "1" ? "active" : "not active"}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue }) => {
        const id = getValue() as string;
        return (
          <ItemAction
            delete_loading={loadingServiceId === id}
            onView={() => navigate(`/services/${id}`)}
            onDelete={() => delete_service(dispatch, id)}
            onEdit={() => editSet(id)}
          />
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <div className="w-full flex justify-between items-center overflow-hidden">
        <h2 className="font-bold text-xl capitalize mb-0">Services</h2>

        <Button
          type="button"
          title="Create"
          children={<FaPlus className="mr-2" />}
          onClick={() => showSet(true)}
          className="px-4"
        />
      </div>

      <div className="flex flex-1 w-full flex-col mt-4 bg-[white]">
        <DataTable columns={columns} data={services} />
      </div>

      <CreateService show={show} onCancel={() => showSet(false)} />
      {edit && (
        <EditService
          show={edit ? true : false}
          id={edit}
          onCancel={() => editSet("")}
        />
      )}
    </div>
  );
};

export default Services;
// function disableLoading(id: string): any {
//   console.log(`Disabling loading for item with ID: ${id}`);
//   throw new Error("Function not implemented.");
// }
